var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from 'react';
import _get from 'lodash/get';
import { Container, Row, Col, Visible, Hidden } from 'react-grid-system';
import { MdSelect as MaterialAutocomplete } from '@bytebrand/fe-ui-core-autobahn/compat';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import FormInput from '../../../ui/FormInput/FormInput';
import FormDropDown from '../../../ui/FormDropDown/FormDropDown';
import SvgClosedLockIcon from '../../../ui/SVG/ClosedLockIcon';
import form, { fields } from '../formConfigs/UpdateProfileFormConfig';
import styles from './../modals.styl';
import { inject, observer } from 'mobx-react';
import { PHONE_PREFIXES } from 'framework/constants/forms';
const col1 = 1;
const col2 = 2;
const col3 = 3;
const col4 = 4;
const col5 = 5;
const col6 = 6;
const col8 = 8;
const col9 = 9;
const col12 = 12;
const col35 = 3.5;
const formInputProps = {
    className: styles.inputWrapper,
    errorPosition: 'BottomRight',
    errorClassName: styles.error
};
const formSelectProps = {
    className: styles.selectWrapper,
    errorPosition: 'BottomRight',
    errorClassName: styles.error
};
let UpdateProfileForm = class UpdateProfileForm extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "isSubmitted", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "componentWillUnmount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (!this.isSubmitted) {
                    this.props.onClose();
                }
            }
        });
        Object.defineProperty(this, "onSubmit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { onError, onSuccess } = this.props;
                this.setState({
                    isLoading: true
                });
                form.submit()
                    .then((form) => {
                    this.setState({
                        isLoading: false
                    });
                    if (form.hasError) {
                        onError();
                    }
                    else {
                        this.isSubmitted = true;
                        onSuccess();
                    }
                })
                    .catch(() => {
                    this.setState({
                        isLoading: false
                    });
                });
            }
        });
        Object.defineProperty(this, "onCloseClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                const { onClose } = this.props;
                this.isSubmitted = true;
                event.preventDefault();
                onClose();
            }
        });
        this.state = {
            isLoading: false
        };
        const { userProfile: { privateAddress, email }, tempPassword } = this.props;
        form.init(fields);
        form.set('default', { ...privateAddress, email });
        form.each((field) => {
            if (!field.hasNestedFields) {
                field.reset(false);
            }
        });
        if (!tempPassword) {
            form.del('email');
            form.del('password');
        }
    }
    render() {
        const { t, isAuthorized, userProfile } = this.props;
        const { isLoading } = this.state;
        const hasMainPhone = _get(userProfile, 'privateAddress.phoneMain', false);
        const descriptionText = isAuthorized
            ? t('modals:offerRequest.registrationMessageLoggedIn')
            : t('modals:offerRequest.registrationMessageNoLogged');
        return (React.createElement(Container, { fluid: true, className: styles.RegistrationForm },
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement("p", { className: styles.description }, descriptionText))),
            React.createElement(Row, { className: styles.formRow },
                React.createElement(Hidden, { xs: true },
                    React.createElement(Col, { sm: col3, className: styles.formLabel }, `${t(form.$('gender').label)}`)),
                React.createElement(Col, { sm: col35, xs: col6 },
                    React.createElement(FormDropDown, { t: t, field: form.$('gender'), namespace: 'common', style: undefined, ...formSelectProps })),
                React.createElement(Hidden, { xs: true },
                    React.createElement(Col, { sm: col1, className: styles.formLabel }, `${t(form.$('title').label)}`)),
                React.createElement(Col, { sm: col35, xs: col6 },
                    React.createElement(FormDropDown, { t: t, field: form.$('title'), namespace: 'common', style: undefined, ...formSelectProps }))),
            React.createElement(Row, { className: styles.formRow },
                React.createElement(Hidden, { xs: true },
                    React.createElement(Col, { sm: col3, className: styles.formLabel }, `${t(form.$('firstName').label)}`)),
                React.createElement(Col, { sm: col8, xs: col12 },
                    React.createElement(FormInput, { t: t, className: styles.inputWrapper, field: form.$('firstName'), autoComplete: "given-name", ...formInputProps }))),
            React.createElement(Row, { className: styles.formRow },
                React.createElement(Hidden, { xs: true },
                    React.createElement(Col, { sm: col3, className: styles.formLabel }, `${t(form.$('lastName').label)}`)),
                React.createElement(Col, { sm: col8, xs: col12 },
                    React.createElement(FormInput, { t: t, field: form.$('lastName'), autoComplete: "family-name", ...formInputProps }))),
            React.createElement(Row, { className: styles.formRow },
                React.createElement(Hidden, { xs: true },
                    React.createElement(Col, { sm: col3, className: styles.formLabel }, `${t(form.$('street').label)} / ${t(form.$('number').label)}`)),
                React.createElement(Col, { sm: col6, xs: col9 },
                    React.createElement(FormInput, { t: t, field: form.$('street'), ...formInputProps })),
                React.createElement(Col, { sm: col2, xs: col3 },
                    React.createElement(FormInput, { t: t, field: form.$('number'), ...formInputProps }))),
            React.createElement(Row, { className: styles.formRow },
                React.createElement(Hidden, { xs: true },
                    React.createElement(Col, { sm: col3, className: styles.formLabel }, `${t(form.$('zip').label)} / ${t(form.$('city').label)}`)),
                React.createElement(Col, { sm: col2, xs: col3 },
                    React.createElement(FormInput, { t: t, field: form.$('zip'), ...formInputProps })),
                React.createElement(Col, { sm: col6, xs: col9 },
                    React.createElement(FormInput, { t: t, field: form.$('city'), ...formInputProps }))),
            React.createElement(Row, { className: styles.formRow },
                React.createElement(Hidden, { xs: true },
                    React.createElement(Col, { sm: col3, className: styles.formLabel }, t(form.$('phoneMain').label))),
                hasMainPhone ? (React.createElement(Col, { xs: col12, sm: col8 },
                    React.createElement(FormInput, { t: t, field: form.$('phoneMain.phoneNumber'), ...formInputProps }))) : (React.createElement(React.Fragment, null,
                    React.createElement(Col, { xs: col3, sm: col2 },
                        React.createElement(MaterialAutocomplete, { onChange: (value) => form.$('phoneMain.countryCode').onChange(value), label: t(form.$('phoneMain.countryCode').placeholder), value: form.$('phoneMain.countryCode').value, error: form.$('phoneMain.countryCode').hasError && form.$('phoneMain.countryCode').error, required: form.$('phoneMain.countryCode').value === '' ? true : false, items: PHONE_PREFIXES, size: 'custom', className: 'countryCode', disableClearable: true, listWithImage: 'true' })),
                    React.createElement(Col, { xs: col3, sm: col2 },
                        React.createElement(FormInput, { t: t, field: form.$('phoneMain.areaCode'), ...formInputProps })),
                    React.createElement(Col, { xs: col6, sm: col4 },
                        React.createElement(FormInput, { t: t, field: form.$('phoneMain.phoneNumber'), ...formInputProps }))))),
            (form.has('email') && form.has('password')) && (React.createElement(React.Fragment, null,
                React.createElement(Row, { className: styles.formRow },
                    React.createElement(Hidden, { xs: true },
                        React.createElement(Col, { sm: col3, className: styles.formLabel }, t(form.$('email').label))),
                    React.createElement(Col, { sm: col8 },
                        React.createElement(FormInput, { t: t, field: form.$('email'), autoComplete: 'off', disabled: true, ...formInputProps }))),
                React.createElement(Row, { className: `${styles.formRow} ${styles.formPasswordRow}` },
                    React.createElement(Hidden, { xs: true },
                        React.createElement(Col, { sm: col3, className: styles.formLabel }, t(form.$('password').label))),
                    React.createElement(Col, { sm: col8 },
                        React.createElement(FormInput, { t: t, field: form.$('password'), autoComplete: 'off', ...formInputProps, errorClassName: styles.passwordError }))))),
            React.createElement(Row, { className: styles.terms },
                React.createElement(Hidden, { xs: true },
                    React.createElement(Col, { sm: col3, className: styles.pseudoLinkLabel },
                        React.createElement("a", { href: '#', className: styles.pseudoLink, onClick: this.onCloseClick }, t('modals:offerRequest.close')))),
                React.createElement(Col, { xs: col12, sm: col5, offset: { sm: 1 } },
                    React.createElement(Button, { className: styles.confirm, variant: 'filled', onClick: this.onSubmit, disabled: isLoading }, isLoading ? React.createElement("span", { className: 'auth-spinner', style: { width: 18, height: 18, borderWidth: 2 } }) : t('modals:offerRequest.saveNow')))),
            React.createElement(Visible, { xs: true },
                React.createElement(Row, { className: styles.mobileBottomText },
                    React.createElement(Col, { xs: col3 },
                        React.createElement("a", { href: '#', className: styles.pseudoLink, onClick: this.onCloseClick }, t('modals:offerRequest.close'))),
                    React.createElement(Col, { xs: col9 },
                        React.createElement("div", null,
                            React.createElement("span", { className: styles.securityDescription },
                                React.createElement(SvgClosedLockIcon, { className: styles.closedLockIcon }),
                                React.createElement("span", null, t('modals:offerRequest.securityDescription')))))))));
    }
};
UpdateProfileForm = __decorate([
    inject('appStore'),
    observer,
    __metadata("design:paramtypes", [Object])
], UpdateProfileForm);
export default UpdateProfileForm;
